import formPageDesign from './_src/formPageDesign.vue'
import dragFormWraper from './_src/dragFormWraper'
formPageDesign.install = function(Vue) {
  Vue.component(formPageDesign.name, formPageDesign)
  Vue.component(dragFormWraper.name, dragFormWraper)
}

export default formPageDesign